/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { Dimensions, TouchableOpacity, View } from "react-native";

import { useSelector } from "react-redux";
import { RootState } from "store/types";

import { Button, Text } from "UpduoLibrary";
import {
  skalePrimaryBlue,
  skaleTextGray,
  skaleCommunityGray,
} from "config/UpduoColors";
import DataEntry from "./DataEntry";

const windowWidth = Dimensions.get("window").width;
const textColor = skaleTextGray;

interface ConfirmationPaneProps {
  onBack: Function;
  onPress: Function;
}

export default function ConfirmationView({
  onBack,
  onPress,
}: ConfirmationPaneProps) {
  const startObject = useSelector((state: RootState) => state.startObject);

  return (
    <View
      style={{
        marginHorizontal: windowWidth * 0.1,
        marginBottom: 15,
        alignItems: "center",
      }}
    >
      <Text
        style={{
          color: skaleCommunityGray,
          fontSize: 30,
          fontWeight: "bold",
          marginBottom: 15,
        }}
      >
        {"Confirmation"}
      </Text>
      <Text
        style={{
          alignSelf: "center",
          color: textColor,
          fontSize: 16,
          marginVertical: 20,
        }}
      >
        {"Is this information correct?"}
      </Text>
      <View style={{ alignSelf: "center", height: 100 }}>
        {startObject?.firstName || startObject?.lastName ? (
          <DataEntry
            heading={"Name"}
            value={`${startObject?.firstName} ${startObject?.lastName}`}
          />
        ) : null}
        {startObject?.title ? (
          <DataEntry heading={"Title"} value={startObject?.title} />
        ) : null}
        {startObject?.email ? (
          <DataEntry heading={"Email"} value={startObject?.email} />
        ) : null}
      </View>
      <Button onPress={() => onPress()} text={"Confirm"} />
      <TouchableOpacity
        onPress={() => {
          onBack("confirmationTryAgain");
        }}
        style={{ margin: 20 }}
      >
        <Text
          isHeading={true}
          style={{
            fontSize: 16,
            color: skalePrimaryBlue,
          }}
        >
          {"TRY AGAIN"}
        </Text>
      </TouchableOpacity>
    </View>
  );
}
